'use strict';

(function fPageLoad() {
    if (document.querySelectorAll('.js-news-results').length) { fInitNews(); }
    if (document.querySelectorAll('.js-sticky-header').length) { fStickyHeader(); }
    if (document.querySelectorAll('.js-richtext-collapse-show').length) { fRichtextCollapse(); }
    if (document.querySelectorAll('.js-scrollspy').length) { fInitScrollSpy(); }
    if (document.querySelectorAll('.js-accordion').length) { fAccordion(); }
    if (document.querySelectorAll('.js-menu').length) { fMenuToggle(); }
    if (document.querySelectorAll('.js-video-open').length) { fVideo(); }
    if (document.querySelectorAll('.js-tabs').length) { fInitTabs(); }
    if (document.querySelectorAll('.js-select').length) { fSelect(); }
    if (document.querySelectorAll('.js-cta-popup').length) { fInitSiteCta(); }
    if (document.querySelectorAll('.js-submenu').length) { fSubmenu(); }

    document.onreadystatechange = function () {
        if (document.readyState === "complete") {
            objectFitImages();

            if (document.querySelectorAll('.js-modal-open').length) { fInitModals(); }
            if (document.querySelectorAll('.js-form-validate').length) { fFormValidation(); }
            if (document.querySelectorAll('.js-timeline').length) { fSliderTimeline(); }
            if (document.querySelectorAll('.js-slider-calendar').length) { fSliderCalendar(); }
            if (document.querySelectorAll('.js-slider-inspire').length) { fSliderInspire(); }
            if (document.querySelectorAll('.js-usp').length) { fSliderUsp(); }
            if (document.querySelectorAll('.js-slider-cards').length) { fSliderCards(); }
            if (document.querySelectorAll('.js-slider-media').length) { fSliderMedia(); }
            if (document.querySelectorAll('.js-backtotop').length) { fBacktotop(); }
            if (document.querySelectorAll('.js-disappear').length) { fDisappear(); }
            if (document.querySelectorAll('.js-zoomer').length) { fZoomer(); }
            if (document.querySelectorAll('.js-social-share').length) { fSocialShare(); }
            if (document.querySelector('.js-sticky-bar')) {
                var stickybar = new StickyBar({ el: document.querySelector('.js-sticky-bar') })
            }
        }
    }
})();
